/*
 * 充值记录相关 API
 */
import request from '@/utils/request'

const BASE = '/market/api/marketing/merchant-recharge-record'

/**
 * 获取商户充值记录列表（分页）
 * @param {Object} data 查询参数
 * @returns {Promise} 返回充值记录列表
 */
export function getMerchantRechargeRecordList (data) {
  return request({
    url: `${BASE}/page`,
    method: 'post',
    data
  })
}

